/**
 * This is a regex that gets 4 things out of the url
 * 0. The whole thing you gave it
 * 1. The domain and port
 * 2. The app name
 * 3. The page path
 * 4. The search params
 * @type {RegExp}
 * @example match for http://local.scoir.com:8050/student/test/somepage/213435?ok=true
 * match = [ http://local.scoir.com:8050/, student, test/somepage/213435, ?ok=true ]
 */
const scoirUrlStructureRegularExpression: RegExp = /(\w+:\/\/\w+.\w+.\w+:?\d{0,4}\/)([^/]+)\/([^?]+)(\?.+)?/

/**
 * This is a regex that gets 2 things out of the page string
 * 0. The whole thing you gave it
 * 1. The slash
 * 2. The app name
 * @type {RegExp}
 * @example match for /student/test/somepage/213435?ok=true
 * match = [ '/student', '/', 'student' ]
 */
const scoirUrlPageStructureRegularExpression: RegExp = /^(\/)(\w+)/

// This returns the broken down parts of the given url
const getUrlMatch = (url: string) => {
  let regex = scoirUrlStructureRegularExpression
  if (url[0] === '/') {
    regex = scoirUrlPageStructureRegularExpression
  }
  return url.match(regex)
}

const getMatchIdx = (match: any, idx: number) => {
  return Array.isArray(match) ? (match[idx] ? match[idx] : '') : ''
}

// This gets the app name from the url
export const getApp = (url: string) => {
  const match = getUrlMatch(url)
  return getMatchIdx(match, 2)
}

// this gets the current page within the app of the given url
export const getPage = (url: string) => {
  const match = getUrlMatch(url)
  return getMatchIdx(match, 3)
}

// this gets the current query params of the given url
export const getQueryParams = (url: string) => {
  const match = getUrlMatch(url)
  return getMatchIdx(match, 4)
}

// this gets the root path of the current app
export const getHostedRoot = () => {
  return import.meta.env.BASE_URL
}

// this gets the name of the current app of the page you're on
export const getThisApp = () => {
  return getHostedRoot()?.replace('/', '')
}

// this tells us if the given url has the same app (not including domain and port because those vary)
export const urlIsInThisApp = (url: string) => {
  return getApp(url) === getThisApp()
}
